import type {
  PagedProblems,
  Problem,
  ProblemCreateRequest,
  ProblemListQuery,
  ProblemPatchRequest,
} from '@shared/types/problem';
import { api } from './client';

function buildQueryString(query: ProblemListQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  const qs = params.toString();
  return qs.length === 0 ? '' : `?${qs}`;
}

export async function listProblems(query: ProblemListQuery = {}): Promise<PagedProblems> {
  return api.get<PagedProblems>(`/api/master/problems${buildQueryString(query)}`);
}

export async function getProblem(id: string): Promise<Problem> {
  return api.get<Problem>(`/api/master/problems/${encodeURIComponent(id)}`);
}

export async function createProblem(body: ProblemCreateRequest): Promise<Problem> {
  return api.post<Problem>('/api/master/problems', body);
}

export async function patchProblem(id: string, body: ProblemPatchRequest): Promise<Problem> {
  return api.patch<Problem>(`/api/master/problems/${encodeURIComponent(id)}`, body);
}

export async function deleteProblem(id: string): Promise<void> {
  return api.delete(`/api/master/problems/${encodeURIComponent(id)}`);
}
